export default __webpack_public_path__ + "static/media/Personal finance-rafiki 1.67e62dd1.svg";